import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiReceiptsPublicGet } from '@/entities/receipts/modules/api/receipts';

// PUBLIC receipt fetch for the shareable /receipt/:id page. Disabled until an id
// is present. A 404 (receipt not found) surfaces as query.isError.
export const usePublicReceipt = (id: string | undefined) =>
  useFetch({
    api: () => apiReceiptsPublicGet(id as string),
    keywords: queryKeys.receipts.public(id ?? ''),
    enabled: Boolean(id),
    staleTime: 60_000,
  });
